import React from 'react'
import TmpTypographyCustom from '../TmpTypographyCustom/TmpTypographyCustom';
import { Box } from '@material-ui/core';
import TmpIconCustom from '../TmpIconCustom/TmpIconCustom';
import { ReactComponent as SetaDirecionalDireita } from "../../../assets/icons/seta_direcional_direita.svg";
import { Button } from './Style';

export interface TmpTmpButtonCollapseCustomProps {
    label: string;
    icon: React.ReactElement;
    handleClick: (e: any) => void;
}

export default function TmpButtonCollapseCustom(props: TmpTmpButtonCollapseCustomProps) {
    
    return (
        <React.Fragment>
            <Box display="flex" style={{cursor: "pointer"}} justifyContent="center" onClick={props.handleClick}>
                <Button>
                    <Box mt={2} mb={2}>
                        <TmpTypographyCustom component='heading' size='small' variant='h3' id='titulo-colap'>
                            <Box ml="6%">
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <TmpIconCustom icon={props.icon} size='md' />
                                    <span style={{ padding: "5px", width: "90%" }}>
                                        {props.label}
                                    </span>
                                    <div >
                                        <span>
                                            <TmpIconCustom icon={<SetaDirecionalDireita />} size='md' />
                                        </span>
                                    </div>
                                </div>
                            </Box>
                        </TmpTypographyCustom>
                    </Box>
                </Button>
            </Box>
        </React.Fragment >
    )
}


